import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { Box, ViewerContext } from "dash-ui";

import Header from "flow-components/Header/Header";
import { RoutesPath } from "flow-components/routes/routes";
import Container from "flow-components/Container/Container";

function ProtectedRout({
  children,
  redirectUrl = RoutesPath.SignIn,
  withContainer = true,
  stickyBreadcrumbs,
}: {
  children: JSX.Element;
  redirectUrl?: string;
  withContainer?: boolean;
  stickyBreadcrumbs?: boolean;
}): JSX.Element | null {
  const { account } = useContext(ViewerContext);

  if (!account) {
    return <Navigate to={redirectUrl} replace />;
  }

  if (!withContainer) {
    return <>{children}</>;
  }
  return (
    <Box h="100%">
      <Header />
      <Container stickyBreadcrumbs={stickyBreadcrumbs}>{children}</Container>
    </Box>
  );
}

export default ProtectedRout;
